module.exports = __webpack_public_path__ + "static/media/sticky-notes.8037b419.png";